import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { generateHomeUrl } from '../../utils/url';

const NotFound: React.FC = () => {
  const navigate = useNavigate()
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={<Button type="primary" onClick={() => {
        // navigate('/', { replace: true })
        window.open(generateHomeUrl(), "_self")
      }}>Back Home</Button>}
    />
  );
}

export default NotFound;